'use client';

import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { AtomicLayoutSection } from '@coveo/atomic-react';
import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';
import { useContext } from 'react';
import HeadlessPager from './HeadlessPager';
import { useResults } from './hooks/useResults';

type Props = {
  paginationMicrocopySet: MicrocopyFragment[];
  context: AtomicContext;
};

// About page size: numberOfResults, the number of results per page is defined on as a Query Parameter override on the Query Pipeline level in the Coveo console.
// if we implement Results per page, we should remove the override from Query Pipeline so it can be defined by the user
export const AtomicPaginationSection = ({
  paginationMicrocopySet = [],
  context,
}: Props) => {
  const { searchEngine } = useContext(context);
  const { results: resultState } = useResults(searchEngine);

  if (!resultState?.hasResults) {
    return null;
  }

  return (
    <div className="mt-4 lg:mt-1">
      <AtomicLayoutSection section="pagination">
        <div className="mx-auto">
          <HeadlessPager
            paginationMicrocopySet={paginationMicrocopySet}
            context={context}
          />
        </div>
      </AtomicLayoutSection>
    </div>
  );
};
